import React from 'react'
import { Link } from 'react-router-dom'

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const Footer = (props) => {
    return (
        <footer className={`wpo-site-footer ${props.ftClass}`}>
            <div className="wpo-lower-footer">
                <div className="container">
                    <div className="row">
                        <div className="col col-xs-12">
                            <ul>
                                <li>Copyright &copy; 2026 <Link onClick={ClickHandler} to="/">Isuru Gimhan</Link>. All rights reserved.</li>
                                <li>
                                    <ul className="footer-legal-links">
                                        <li><Link onClick={ClickHandler} to="/privacy">Privacy</Link></li>
                                        <li><Link onClick={ClickHandler} to="/cookies">Cookies</Link></li>
                                        <li><Link onClick={ClickHandler} to="/terms">Terms</Link></li>
                                    </ul>
                                </li>
                                <li>
                                    <ul>
                                        <li><a href="https://www.linkedin.com/in/isurugimhan" target="_blank" rel="noopener noreferrer"><i className="ti-linkedin"></i></a></li>
                                        <li><a href="https://www.instagram.com/isurugimhan.gg" target="_blank" rel="noopener noreferrer"><i className="ti-instagram"></i></a></li>
                                        <li><a href="https://www.facebook.com/isurugimhan.gg" target="_blank" rel="noopener noreferrer"><i className="ti-facebook"></i></a></li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;